import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import {
    getItemTrackingCollection,
    ItemTrackingCollectionParam,
    ItemTrackingCollectionResult,
} from "@tKgpco/Services/ItemTrackingService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<ItemTrackingCollectionParam, ItemTrackingCollectionResult>;

export const DispatchResetItemTrackingCollection: HandlerType = props => {
    props.dispatch({
        type: "Custom/ItemTracking/ResetItemTrackingCollection",
    });
};

export const chain = [DispatchResetItemTrackingCollection];

export const resetItemTrackingCollection = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "resetItemTrackingCollection",
);
export default resetItemTrackingCollection;
